import { Base } from "../core/base.model";
import { TicketPrioridad } from "src/app/utilerias/enums/ticket-prioridad.enum";
import { TicketsEstatus } from "src/app/utilerias/enums/tickets-estatus.enum";

export class Tickets extends Base {
  id_ticket: number;
  asunto: String;
  nombreSolicitante: String;
  areaSolicitante: String;
  areaResolutora: String;
  horas: number;
  minutos: number;
  prioridad!: TicketPrioridad;
  justificacion: String;
  telefonoContacto: string;
  fechaSolicitud: Date;
  fechaUltimaAfectacion: Date;
  id_UsuarioSolicito: number;
  id_UsuarioAtendio: number;
  id_Corporativo: number;
  id_Empresa: number;
  id_estatus: TicketsEstatus;
  id_area: number;
  id_areaResolutora: number;
  id_estatusPrevio: TicketsEstatus;
  nombreEstaus: String;
  aTiempo: boolean;
  siguiente: boolean;
  color: string;
  tiemp: string;
  usuarioSolicitante: String;
  fechaSolicitudConFormato: String;
  actualizado: boolean;
  idAsistencia: string;
  passAsistencia: string;
  tipoSolicitud: string;

  causaOrigenProblema: String;
  paliativo: String;
  solucionDefinitiva: String;
  impacto: String;

  id_empresaDirigido: number;
  fechaProceso: Date;
  id_usuarioProceso: number;
  fechaAtendio: Date;
  fechaVoBo: Date;
  id_usuarioVoBo: number;
  fechaCancelada: Date;
  id_usuarioCancelo: number;

  nombreEmpresaSolicitante: String;
  nombreUsuarioProceso: String;
  nombreUsuarioAtendio: String;
  nombreUsuarioVoBo: String;
  nombreUsuarioCancelo: String;
  tiempoAtencion: number;

  tiempoAtencionString: String;
  cumpleSla: String;

  esResolutor: boolean;
}
